var Handlebars = require("C:\\projects\\FlaTWorld\\node_modules\\handlebars\\runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression;

  return "<span style='font-size:200%;display:block;margin-bottom:20px;'>\r\n  "
    + alias1(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"title","hash":{},"data":data}) : helper)))
    + "\r\n</span>\r\n<ul>\r\n  <li>\r\n    "
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.object : depth0)) != null ? stack1.name : stack1), depth0))
    + "\r\n  </li>\r\n</ul>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./src/UIs/default/layout/singleSelection.handlebars
 ** module id = 249
 ** module chunks = 0
 **/